
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//印尼

export const lang ={
  Please_set_materialtype_in_product_page:"Silakan masuk ke halaman produk untuk memodifikasi dan mengatur jenis material setiap produk - produk jadi - produk setengah jadi - aksesoris.",
deleteAccount:"Keluar",
deleteAccountWillDeleteAllData:"Logout dari akun Anda akan menghapus semua data dan membuat Anda tidak dapat login.",
backupDatabase:"basis data cadangan",
restoreDatabase:"Pulihkan basis data",
materialtype:"Jenis bahan",
Manufacturing:"Versi manufaktur",
Professional:"Versi profesional",
Standard:"edisi Standar",
product:"Produk jadi",
halfProduct:"Produk setengah jadi",
components:"Aksesoris",
Parent:"komponen induk",
Children:"Sub-aksesoris",
Level:"Hirarki",
Timing:"Waktu",
PieceCount:"sepotong-sepotong",
Wages:"Gaji",
InternalProcess:"Proses internal",
ExternalProcess:"proses eksternal",
ProceName:"Nama proses",
ProceIndex:"Perintah eksekusi",
ChargeMan:"kepala sekolah",
BillMethod:"Metode penagihan",
ConsumTime:"jam kerja",
Accessories:"Aksesoris",
Assembly:"Berkumpul",
materials:"bahan",
task:"Tugas",
process:"proses",
BOM:"BOM",
Production:"Produksi",
RestorePurchaseOneUse:"Pulihkan pembelian (satu pengguna (terbatas pada pembelian sebelumnya))",
buy_fail_try_again:"Silakan klik lagi untuk membeli",
Export:"Ekspor",
Date:"tanggal",
BankDetail:"rincian bank",
Seller:"penjual",
Buver:"pembeli",
Currency:"mata uang",
CompanyName:"Nama perusahaan",
ProformaInvoice:"faktur proforma",
Discount:"Diskon",
PayStatus:"Status pembayaran",
ShippingStatus:"Status pengiriman",
FreightType:"Jenis transportasi",
Shipping:"kargo",
Payment:"Pembayaran",
Moneyname:"nama mata uang",
Tax:"pajak",
Freight:"Biaya pengiriman",
Insurance:"Pertanggungan",
Bankfee:"biaya bank",
Qc:"Sertifikasi Mutu",
Exchangerate:"kurs",
Shippingnumber:"nomor pengiriman",
ShipDate:"Tanggal pengiriman",
Arrivedate:"tanggal kedatangan",
Grossweight:"berat kotor",
CubicWeight:"berat kubik",
Totalpackages:"Jumlah total paket",
Moneytype:"jenis mata uang",
Quotedate:"tanggal penawaran",
Validitydate:"Tanggal berlaku",
Paymentterm:"berakhirnya pembayaran",
Priceterm:"istilah harga",
DeliveryTerm:"Waktu pengiriman",
BankName:"nama Bank",
BankAddress:"Alamat bank",
SwiftCode:"Kode Bank",
Review:"Tinjauan",
Signfor:"Tanda tangan untuk tanda terima",
Finance:"keuangan",
Receiver:"Penerima",
Business:"bisnis",
ContactPerson:"Kontak person",
Profit:"laba",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Karyawan harus menggunakan Google Chrome. Silakan periksa alamat IP di halaman bantuan APP komputer layanan utama, lalu masukkan alamat di kolom URL browser komputer lain untuk membuka login",
newPassword:"kata sandi baru",
ForgetPassword:"lupa kata sandinya",
ContactUs:"Hubungi kami/beri saran",
Actualpay_should_big_then_shouldpay:"Penerimaan sebenarnya tidak boleh lebih besar dari piutang",
ShopAddress:"Alamat toko saya Pindai kode QR untuk melakukan pemesanan",
Submit:"kirim",
All:"semua",
OrdernumExists:"Nomor pesanan sudah ada",
PermissionDenied:"izin ditolak",
StockTransfer:"Perpindahan stok",
FromWarehouse:"Transfer keluar gudang",
ToWarehouse:"Transfer ke gudang",
PleaseUseInWebBrowser:"Silakan gunakan fungsi ekspor Excel di Google Chrome",
PleasePrintInWebBrowser:"Silakan gunakan fungsi cetak di Google Chrome",
HistoryPrice:"harga historis",
SerialNumber:"nomor seri",
Please_Use_In_APP:"Silakan gunakan dalam perangkat lunak komputer",
Please_Purchase_In_APP:"Silakan membeli di dalam APLIKASI, bukan di dalam browser",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Anda dapat terhubung ke database Postgresql. Data Anda akan disimpan di database Postgresql. Secara default, Anda tidak perlu terhubung ke database Postgresql. Defaultnya adalah database Sqlite lokal.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Hubungkan ke database Postgresql, data Anda akan disimpan di database Postgresql, dan data akan dibaca kembali",
Use_sqlite_data_will_store_in_local:"Menggunakan sqlite, data akan disimpan di mesin lokal",
UsePostgresqlDatabase:"Menggunakan basis data PGSQL",
UseSqliteDatabase:"Menggunakan basis data Sqlite",
DatabaseName:"Basis data nama",
Test_connect:"tes koneksi",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Jika produk mempunyai warna atau ukuran, silahkan isi 0 untuk persediaan awal, setelah menambahkan produk, masukkan persediaan pada pembelian.",
my:"milikku",
my_shop_qrcode_scan:"Kode QR toko saya memberi pelanggan kemampuan untuk memindai kode untuk melakukan pemesanan. Ponsel pelanggan harus terhubung ke router yang sama dengan komputer Anda.",
ip:"AKU P",
port:"Pelabuhan",
orderstatus:"Status pemesanan",
image:"gambar",
Template:"templat",
Please_select_a_excel_file:"Silakan pilih file",
Please_select_only_one_excel_file:"Hanya satu file yang dapat dipilih",
Connect_Internet_Login_again:"Hubungkan ke Internet dan masuk lagi sebelum membeliSilakan masuk ke halaman produk untuk memodifikasi dan mengatur jenis material setiap produk - produk jadi - produk setengah jadi - aksesoris.",

    productHasValidDate:'Produk memiliki periode yang valid',
productHasColor:'Produk memiliki ukuran warna',
GeneralGoods:'Barang umum',
Selected:'Dipilih',
RestorePurchase:'Lanjutkan pembelian',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Beli pengguna Faktur Perusahaan Edisi 10 secara permanen',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Pembelian Faktur Edisi Perusahaan tidak terbatas untuk pengguna dan perangkat',
Purchasing:'Membeli ... Harap tunggu dengan sabar ...',
Validdate:'Masa berlaku',
Makedate:'Tanggal produksi',
Batch:'Batch',
CheckVersion:'Periksa versi',
Please_set_this_ip_address_on_App:'Silakan setel alamat IP ini atau alamat IP komputer pada APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Buka koneksi ini di komputer atau browser seluler Anda (sambungkan WiFi yang sama)',


    CheckVersion:'Periksa versi',
You_need_to_purchase:'Anda belum membeli, tambahkan WeChat ke Elink9988 E-mail:bvbuy@qq.com',
Thank_for_your_purchase:'Anda sudah membeli',
New_version_available:'Ada versi baru',
Is_the_latest_version:'adalah versi terbaru',

    please:'silahkan',
input:'memasukkan',
wrong:'salah',
Verifycode:'Kode verifikasi',
Upload:'Unggah',
Download:'Unduh',
You_need_to_purchase_to_continue_use:'Anda harus membeli untuk terus menggunakan',
CheckBuy:'Periksa Pembelian',
Exists:'Ada',
NetworkUnavailable:'Jaringan Tidak Tersedia',
Today:'Hari ini',
Yesterday:'Kemarin',
ThisMonth:'Bulan ini',
LastMonth:'Bulan lalu',
nickname:'nama panggilan',
storeName:'Nama toko',
BuyStandAlone:'Beli versi yang berdiri sendiri',
PermissionDenied:'Izin ditolak',
Boss:'Boss',
    login:'Masuk',
    operate:'Beroperasi',
    register:'Daftar',
    username:'Nama pengguna',
    password:'Kata sandi',
    User:'Pengguna',
    ok:'baik',
    back:'Kembali',
    success:'Keberhasilan',
    fail:'Gagal',
    cancel:'Membatalkan',
    add:'Menambahkan',
    edit:'Edit',
    delete:'Menghapus',
    refresh:'Menyegarkan',
    close:'Dekat',
    cancel:'Membatalkan',
    return:'Kembali',
    ElinkInvoice:'Faktur Elink',
    Purchase:'Membeli',
    BaseData:'Data Dasar',
    Sell:'Menjual',
    PurchaseReturns:'Pengembalian pembelian',
    SellReturns:'Jual kembali',
    Inventory:'Inventaris',
    Statistics:'Statistik',
    Receivable:'Piutang',
    Payable:'Dibayar',
    Orders:'Pesanan',
    StockTransfer:'Transfer Saham',
    StockRecall:'Penarikan Saham',
    Customer:'Pelanggan',
    Supplier:'Pemasok',
    Warehouse:'Gudang',
    Color:'Warna',
    Size:'Ukuran',
    Category:'Kategori',
    Category2:'Kategori2',
    Product:'Produk',
    Account:'Rekening',
    AccountType:'Kategori akun',
    Staff:'Staf',
    typeone:'Kategori',
    typetwo:'Subkategori',
    ProductName:'Nama Produk',
    Specification:'Spesifikasi',
    Barcode:'Kode batang',
    Buyprice:'Harga beli',
    Sellprice:'Harga jual',
    Wholesaleprice:'Harga grosir',
    Currentstock:'Dorongan arus',
    Unit:'Satuan',
    Initstock:'Stok init',
    Parameter:'Parameter',
    Remark:'Ucapan',
    Supplier:'Pemasok',
    Customer:'Pelanggan',
    Staff:'Staf',
    Receivable:'Piutang',
    payable:'terutang',
    Receipts:'Tanda terima',
    Paid:'Dibayar',
    Preferential:'Istimewa',
    DateDay:'Tanggal',
    OrderNum:'Jumlah order',
    Name:'Nama',
    UserName:'Nama pengguna',
    IdNum:'Nomor ID',
    BirthDay:'Ulang tahun',
    SEX:'Seks',
    Female:'Wanita',
    Male:'Pria',
    Select:'Memilih',
    Address:'Alamat',
    Phone:'Telepon',
    Email:'E-mail',
    CardNum:'Nomor kartu',
    Price:'Harga',
    QTY:'Jumlah',
    SupplierCategory:'Kategori Pemasok',
    CustomerCategory:'Kategori Pelanggan',
    Power:'Kekuasaan',
    Role:'Peran',
    save:'Menyimpan',
    image:'gambar',
    search:'Pencarian',
    Year:'Tahun',
    Month:'Bulan',
    Day:'Hari',
    Total:'Total',
    WorkReport:'Laporan Kerja',
    Leave:'Meninggalkan',
    CheckIn:'Mendaftar',
    Announcement:'Pengumuman',
    Approval:'Persetujuan',
    Tracking:'Pelacakan',
    Bill:'Tagihan',
    OrdersDetail:'Detail Pesanan',
    Expense:'Biaya',
    Income:'Pendapatan',
    Userfor:'Userfor',
    Amount:'Jumlah',
    Title:'Judul',
    News:'Berita',
    SelectFile:'Pilih file',
    Content:'Konten',
    Cost:'Biaya',
    ApprovalUser:'Pengguna Persetujuan',
    ApprovalStatus:'status persetujuan',
    ApprovalRemark:'Keterangan Persetujuan',
    ApprovalDate:'Tanggal Persetujuan',
    SubmitDate:'Tanggal Kirim',
    Status:'Status',
    FromDateTime:'Dari Tanggal Waktu',
    ToDateTime:'Sampai Tanggal Waktu',
    Subject:'Subyek',
    Latitude:'Lintang',
    Longitude:'Garis bujur',
    Print:'Mencetak',
    DataTrans:'DataTrans',
    OA:'OA',
    Setting:'Pengaturan',
    Help:'Membantu',
    ScanOpenInPhone:'Pindai Buka di Telepon',
    Building:'Bangunan',
    Room:'Kamar',
    HotelCheckIn:'Mendaftar',
    CheckOut:'Periksa',
    Hotel:'Hotel',
    Checkintime:'Waktu check-in',
    Checkouttime:'Waktu check out',
    Deposit:'Deposito',
    Cost:'Biaya',
    RoomNum:'Nomor Kamar',
    Rent:'Menyewa',
    costday:'costday',
    rent:'menyewa',
    waternum:'Tingkat air',
    electricnum:'Gelar listrik',
    gasnum:'Tingkat gas',
    watercost:'biaya air',
    electriccost:'biaya listrik',
    gascost:'biaya gas',
    cleaningcost:'biaya pembersihan',
    networkcost:'biaya jaringan',
    tvcost:'biaya tv',
    managecost:'mengelola biaya',
    othercost:'biaya lainnya',
    totalcost:'total biaya',
    remark:'ucapan',
    addtime:'tambahkan waktu',
    OpenInBrowser:'Buka di browser',
    InventoryProfit:'Laba persediaan',
    InventoryLoss:'Kerugian persediaan',
    Buy:'Membeli',

Refresh:'Segarkan',
Add:'Tambah',
Search:'Cari',
Records:'catatan',
}



// WEBPACK FOOTER //
// ./src/lang/id.js